import {DataStatus} from 'platform/components';

import {useGetSignableDocumentListQuery} from '@dms/api/core';

import {useDocumentSelection} from '../../contexts/DocumentSelectionProvider';
import {StepContentProps} from '../../types/StepContentProps';
import {SignatoriesSelectForm} from './components/SignatoriesSelectForm';
import {useDefaultSignatoriesData} from './hooks/useDefaultSignatoriesData';

export function SignatoriesSelectStep(props: StepContentProps) {
  const {signatureDocumentFileIds} = useDocumentSelection();

  const {
    data: activeTransactionFiles,
    isLoading: isDocumentListLoading,
    isError: isDocumentListError,
  } = useGetSignableDocumentListQuery({
    files: signatureDocumentFileIds,
  });

  const {
    defaultSignatoriesData,
    documentDefaultSignatoriesData,
    isLoading: isDefaultsLoading,
    isError: isDefaultsError,
  } = useDefaultSignatoriesData(props.customerId);

  return (
    <DataStatus
      isLoading={isDocumentListLoading || isDefaultsLoading}
      isError={isDocumentListError || isDefaultsError}
      minHeight="100%"
    >
      <SignatoriesSelectForm
        {...props}
        documents={activeTransactionFiles ?? []}
        initialDefaults={defaultSignatoriesData}
        documentDefaults={documentDefaultSignatoriesData}
      />
    </DataStatus>
  );
}
